import { colorPalette } from '../../colorPalette';
export const titleStyle = (size) => ({
    marginLeft: size === 'small' ? '4px' : '8px',
    fontSize: size === 'small' ? '12px ' : '14px',
    lineHeight: size === 'small' ? '16px ' : '18px',
});
export const container = (size, positionV, positionH) => ({
    backgroundColor: colorPalette.white,
    color: colorPalette.gray700,
    display: 'flex',
    justifyContent: 'center',
    marginLeft: size === 'small' ? '8px' : '16px',
    margin: 0,
    position: 'absolute',
    top: positionV === 'top' ? 0 : 'auto',
    bottom: positionV === 'bottom' ? 0 : 'auto',
    left: positionH === 'left' ? 0 : 'auto',
    right: positionH === 'right' ? 0 : 'auto',
    borderRadius: size === 'small' ? '16px' : '24px',
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 2px 2px 0px rgba(0, 0, 0, 0.12)',
    padding: size === 'small' ? '4px 12px 4px 12px ' : size === 'medium' ? '11px 12px 11px 12px' : '15px 16px 15px 16px',
    ['& > *']: {
        justifySelf: 'center',
    },
    [`&:focus`]: {
        border: `1px solid ${colorPalette.lightBlue800}`,
    },
    [`&:disabled`]: {
        backgroundColor: colorPalette.gray100,
        color: colorPalette.gray300,
    },
    ['&:active']: {
        backgroundColor: colorPalette.gray300,
    },
});
export const onlyIcon = (size, positionV, positionH) => ({
    backgroundColor: colorPalette.white,
    color: colorPalette.gray700,
    fontSize: '1.4rem',
    margin: '8px',
    position: 'absolute',
    top: positionV === 'top' ? 0 : 'auto',
    bottom: positionV === 'bottom' ? 0 : 'auto',
    left: positionH === 'left' ? 0 : 'auto',
    right: positionH === 'right' ? 0 : 'auto',
    borderRadius: size === 'small' ? '16px' : '24px',
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 2px 2px 0px rgba(0, 0, 0, 0.12)',
    padding: size === 'small' ? '4px ' : size === 'medium' ? '8px' : ' 12px',
    [`&:focus`]: {
        border: `1px solid ${colorPalette.lightBlue800}`,
    },
    [`&:disabled`]: {
        backgroundColor: colorPalette.gray100,
        boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.14), 0px 2px 2px 0px rgba(0, 0, 0, 0.12)',
        color: colorPalette.gray300,
    },
});
export const iconStyle = (size) => ({
    lineHeight: size === 'small' ? '9px ' : '11px',
});
